<script>
export default {
  props: {
    // Documento vindo da API — quando ainda não existe, chega só com status 'pending'
    doc: {
      type: Object,
      default: () => ({}),
    },
    label: {
      type: String,
      default: "",
    },
    // Trava o botão enquanto o upload da própria linha está em andamento
    busy: {
      type: Boolean,
      default: false,
    },
    // Documento de assinatura (Autentique) — troca envio por gerar / copiar link
    signType: {
      type: Boolean,
      default: false,
    },
    border: {
      type: Boolean,
      default: false,
    },
    // Linha inativa — permanece visível, mas esmaecida e sem ação de envio
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusMap: {
        pending:  { label: "PENDENTE",   badge: "badge-soft-danger" },
        sent:     { label: "AGUARDANDO", badge: "badge-soft-info" },
        signed:   { label: "ASSINADO",   badge: "badge-soft-success" },
        refused:  { label: "RECUSADO",   badge: "badge-soft-danger" },
        uploaded: { label: "EM ANÁLISE", badge: "badge-soft-warning" },
        approved: { label: "APROVADO",   badge: "badge-soft-success" },
        rejected: { label: "REPROVADO",  badge: "badge-soft-danger" },
      },
    };
  },
  computed: {
    status() {
      return this.doc.status || "pending";
    },
    statusInfo() {
      if (this.disabled) {
        return { label: "INATIVO", badge: "badge-soft-secondary" };
      }
      return this.statusMap[this.status] || null;
    },
    // Envio liberado só antes da análise ou depois de reprovado pelo admin
    canUpload() {
      return ["pending", "rejected"].includes(this.status);
    },
  },
  methods: {
    triggerUpload() {
      this.$refs.fileInput.click();
    },
    onFileChange(event) {
      this.$emit("upload", event);
    },
  },
};
</script>

<template>
  <div class="d-flex align-items-center justify-content-between py-3" :class="border ? 'border-bottom' : ''">
    <div>
      <slot>
        <div class="font-size-13">{{ label }}</div>
      </slot>
      <span class="badge font-size-11 mt-1" :class="[statusInfo.badge, disabled ? 'document-row-disabled' : '']" v-if="statusInfo">{{ statusInfo.label }}</span>
      <div class="text-danger font-size-11 mt-1" v-if="!disabled && status === 'rejected' && doc.rejection_reason">
        {{ doc.rejection_reason }}
      </div>
    </div>
    <div class="d-flex align-items-center flex-gap-5" :class="disabled ? 'document-row-disabled' : ''">
      <template v-if="!signType">
        <template v-if="canUpload">
          <input ref="fileInput" type="file" accept="image/*,application/pdf" capture="environment" style="display: none" v-on:change="onFileChange($event)">
          <button class="btn btn-sm btn-outline-default" :disabled="busy || disabled" v-on:click="triggerUpload()">
            {{ status === 'rejected' ? 'Reenviar' : 'Enviar' }}
            <b-spinner v-if="busy" small class="ml-1 align-middle" role="status"></b-spinner>
          </button>
        </template>
      </template>
      <template v-else>
        <button v-if="status === 'pending' || status === 'refused'" class="btn btn-sm btn-outline-default" v-on:click="$emit('generate')">
          Gerar
        </button>
        <button v-if="status === 'sent' && doc.sign_url" class="btn btn-sm btn-outline-secondary" v-on:click="$emit('copy')">
          Copiar link
        </button>
      </template>
    </div>
  </div>
</template>

<style scoped>
button:disabled {
  opacity: 0.3;
  cursor: not-allowed;
}

/* Órgão desligado: a linha continua visível, só perde o destaque */
.document-row-disabled {
  opacity: 0.5;
}
</style>
